import { Chip, ChipPropsColorOverrides } from '@mui/material';
import { ExpenseStatus } from '../../../interfaces/delivery-company/expenses';
import { Cancel, Done, HourglassBottom } from '@mui/icons-material';
import { OverridableStringUnion } from '@mui/types';

const get_styles = (
  state: ExpenseStatus
): {
  icon: JSX.Element;
  color: OverridableStringUnion<
    | 'default'
    | 'primary'
    | 'secondary'
    | 'error'
    | 'info'
    | 'success'
    | 'warning',
    ChipPropsColorOverrides
  >;
} => {
  const defaultIconStyle: any = { fontSize: 'small' };

  switch (state) {
    case ExpenseStatus.PENDING:
      return {
        color: 'warning',
        icon: <HourglassBottom {...defaultIconStyle} />,
      };
    case ExpenseStatus.PAID:
      return { color: 'success', icon: <Done /> };
    case ExpenseStatus.CANCELLED:
      return { color: 'secondary', icon: <Cancel /> };
  }
};

export const showExpenseState = (state: ExpenseStatus): JSX.Element => {
  const styles = get_styles(state);
  return <Chip label={state} icon={styles.icon} color={styles.color} />;
};
